"use client"

import { useEffect, useState } from 'react'
import { SignedIn, SignedOut, SignOutButton, UserButton } from '@clerk/nextjs'
import { LogOut } from 'lucide-react'
import { Button } from '@/shared/ui/button'

/**
 * 인증 헤더 (클라이언트 컴포넌트)
 *
 * Clerk 컴포넌트들이 SSR에서 hydration 불일치를 일으키므로
 * 클라이언트에서만 렌더링되도록 분리했습니다.
 */
export function AuthHeader() {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    <header className="flex-shrink-0 flex justify-between items-center h-16 px-4 border-b bg-background">
      <h1 className="text-xl font-bold">AI Avatar Builder</h1>
      <div className="flex items-center gap-4">
        {isMounted ? (
          <>
            <SignedIn>
              <div className="flex items-center gap-2">
                <UserButton afterSignOutUrl="/" />
                <SignOutButton redirectUrl="/">
                  <Button variant="ghost" size="sm" className="gap-2">
                    <LogOut className="h-4 w-4" />
                    로그아웃
                  </Button>
                </SignOutButton>
              </div>
            </SignedIn>
            <SignedOut>
              <span className="text-sm text-gray-600">Please sign in</span>
            </SignedOut>
          </>
        ) : (
          // SSR/Hydration 중에는 플레이스홀더 표시
          <div className="h-8 w-24" />
        )}
      </div>
    </header>
  )
}
